<template>
    <v-layout column align-end>
        <list-edition-toolbar
            :buttons="toolbarButtons"
            @add="startEditingItem(null, 'create')"
        />
        <v-dialog
            v-if="itemEditionDialog"
            :value="itemEditionDialog"
            persistent
            max-width="350"
        >
            <v-card color="#f0f0ef" min-height="160">
                <v-card-text class="text-left pt-1">
                    <label class="mixed-input-container-size">{{ $tc('Type', 1) }} *</label>
                    <treeselect
                        v-model="editedItem.type"
                        :options="stepOptions"
                        disableFuzzyMatching
                        class="mt-1 mixed-input-container-size"
                    />
                    <div class="mixed-input-container-size">
                        <label>{{$tc('Label')}} *</label>
                        <input class="mixed-task-input" type="text" v-model="editedItem.label"/>
                    </div>
                    <div class="mixed-input-container-size">
                        <label>{{$tc('Index')}} *</label>
                        <input class="mixed-task-input" type="number" v-model="editedItem.index"/>
                    </div>
                    <v-checkbox
                        :label="$tc('Required')"
                        v-model="editedItem.required"
                        color="accent"
                        class="mt-1"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <management-button
                        type="cancel"
                        :label="$t('Cancel')"
                        @buttonClick="close"
                    />
                    <management-button
                        type="execute"
                        :label="itemIndex !== -1 ? $t('ApplyChanges') : $t('Add')"
                        :disabled="isBtnDisabled"
                        @buttonClick="applyChanges"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <mixed-table
            :list="editedText"
            :edition-disabled="editionDisabled"
            :allRows="rowsPerPage"
            @editItem="startEditingItem($event, 'edit')"
            @removeItem="tryRemoveItem"
        />
        <photos
            class= "photos"
            v-if="photoList.length > 0"
            :tasks="photoList"
            :taskDecisionButtons="false"
            :taskContents="taskContents"
            :isMixedTask="true"
            @updateTaskContents="$emit('updateTaskContents',$event)"
            @approveTask="$emit('approveTask')"
            @rejectTask="$emit('rejectTask',$event)"
        />
        <app-dialog-box
            :open="itemDeleteDialog"
            :title="$t('DeleteItem')"
            :content="$t('DeleteConfirmation') + ' ' + itemToEdit.label + '?'"
            :main-action-label="$t('No')"
            @mainAction="itemDeleteDialog = false"
            :secondary-action-label="$t('Yes')"
            @secondaryAction="removeItem"
        />
    </v-layout>
</template>

<script>
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import managementButton from "@/components/Management/ManagementButton";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import MixedTable from "./MixedTable.vue"
import Photos from '@/components/FieldManagement/FieldWork/Data/TaskType/Photos.vue/';
export default {
    name: "Mixed",
    components: {
        ListEditionToolbar,
        managementButton,
        AppDialogBox,
        MixedTable,
        Photos,
    },
    props: {
        task: {
            type: Object,
            required: true
        },
        editionDisabled: {
            type: Boolean
        },
        rowsPerPage: {
            type: Array
        },

    },
    data(){
        return{
            editedItem: {
                label: null,
                index: null,
                type: null,
                required: true,
                value: false
            },
            itemEditionDialog: false,
            itemDeleteDialog: false,
            stepOptions: [
                { id: "checklist", label: this.$i18n.t("Checklist") },
                { id: "text", label: this.$i18n.t("Text") },
                { id: "photo", label: this.$i18n.tc("Photo", 1) },
            ],
            itemIndex: -1,
            itemToEdit: {},
            editedText: [],
        }
    },
    mounted() {
        this.setUpData();
    },
    computed: {
        originalChecklistItems() {
            if (this.task.hasOwnProperty("content")) {
                return this.task.content;
            }
            return this.task;
        },
        toolbarButtons() {
            return [
                {
                    id: "add",
                    icon: "add_circle",
                    tooltip: this.$i18n.t("AddItem"),
                    active: true,
                    disabled: this.editionDisabled
                }
            ];
        },
        isBtnDisabled() {
            return (!!this.editedItem.type && !!this.editedItem.label && !!this.editedItem.index ? false : true);
        },
        photoList(){
           return this.task.content.filter(element => element.type === 'photo');
        },
    },
    methods:{
        setUpData() {
            this.editedText = Array.from(this.originalChecklistItems);
        },
        close() {
            this.itemEditionDialog = false;
            this.editedItem = {
                label: null,
                index: null,
                type: null,
                required: false,
                value: false
            }
            this.itemIndex = -1;
        },
        applyChanges() {
            if (this.itemIndex === -1) {
                this.$emit("addItems", this.editedItem);
            } else {
                this.$emit("editItems", this.editedItem, this.itemIndex);
            }
            this.close();
        },
        startEditingItem(item, actionType) {
            if (actionType === "edit") {
                this.itemIndex = this.task.content.indexOf(item);
                this.editedItem = {...item};
            }
            this.openEditingDialog();
        },
        openEditingDialog() {
            this.itemEditionDialog = true;
        },
        tryRemoveItem(itemToDelete) {
            this.itemToEdit = itemToDelete;
            this.itemDeleteDialog = true;
        },
        removeItem() {
            const index = this.editedText.indexOf(this.itemToEdit);
            this.editedText.splice(index, 1);
            this.$emit("removeItem", index, this.itemToEdit.uuid);
            this.itemToEdit = {};
            this.itemDeleteDialog = false;
        },
    },
    watch: {
        originalChecklistItems() {
            this.setUpData();
        }
    }
}
</script>
<style>
.mixed-input-container-size{
    font-size: 12px;
}
.mixed-task-input{
    background-color: white;
    width: 100%;
    font-size: 12px;
}
.photos{
    align-self: baseline;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Mixed/Mixed.vue